module.exports = __webpack_public_path__ + "static/img/til67.568825a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til67.png
// module id = ZfQE
// module chunks = 1